import { render } from "./AudienceSelector.vue?vue&type=template&id=49a7e967&scoped=true"
import script from "./AudienceSelector.vue?vue&type=script&lang=js"
export * from "./AudienceSelector.vue?vue&type=script&lang=js"

import "./AudienceSelector.vue?vue&type=style&index=0&id=49a7e967&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a7e967"],['__file',"resources/js/components/playbooks/admin/AudienceSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49a7e967"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49a7e967', __exports__)) {
    api.reload('49a7e967', __exports__)
  }
  
  module.hot.accept("./AudienceSelector.vue?vue&type=template&id=49a7e967&scoped=true", () => {
    api.rerender('49a7e967', render)
  })

}


export default __exports__